import React from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import createForm from "./Form";
import DateTimeInput from "../../form/DateTimeInput";
import {OptionFormatter} from "../../../utils/formatters";
import TextArea from "../../form/TextArea";
import Items from "./StockTransfer/Items";
import ComponentField from "../../form/ComponentField";

class WriteOffForm extends React.Component {

    render() {
        return (
            <form onSubmit={ this.props.handleSubmit }>
                <div className="row form-row">
                    <div className="col-sm-6">
                        <TextInput
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                        />
                    </div>
                    <div className="col-sm-6">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="pid"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-4">
                        <TextInput
                            {...this.props.getFieldProps("StockOperationState")}
                            disabled={true}
                            name="StockOperationState"
                            value={this.props.values.StockOperationState}
                            formatter={OptionFormatter}
                            label="Státusz"
                        />
                    </div>
                    <div className="col-md-4">
                        <Select
                            {...this.props.getFieldProps("writeoff_type")}
                            disabled={true}
                            objectValue={false}
                            name="writeoff_type"
                            optionname="WriteoffType"
                            storeType="local"
                            value={this.props.values.writeoff_type}
                            saveChanges={this.props.setFieldValue}
                            label="Típus"
                        />
                    </div>
                    <div className="col-md-4">
                        <DateTimeInput
                            name="transaction_date"
                            value={this.props.values.transaction_date}
                            label="Szállítás dátuma"
                            showTime={false}
                            disabled={true}
                            {...this.props.getFieldProps("transaction_date")}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-4">
                        <Select
                            label="Honnan"
                            name="from"
                            component="location"
                            objectValue={true}
                            labelKey="name"
                            storeType="remote"
                            disabled={true}
                            value={this.props.values.origin}
                            {...this.props.getFieldProps("origin")}
                            saveChanges={this.setFieldValue}
                        />
                    </div>
                    <div className="col-md-4">
                        <Select
                            label="Partner"
                            name="recipient"
                            component="partner"
                            objectValue={true}
                            labelKey="name"
                            storeType="remote"
                            disabled={true}
                            value={this.props.values.recipient}
                            {...this.props.getFieldProps("recipient")}
                            saveChanges={this.setFieldValue}
                        />
                    </div>
                    <div className="col-md-4">
                        <Select
                            label="Hova"
                            name="to"
                            component="location"
                            objectValue={true}
                            labelKey="name"
                            storeType="remote"
                            disabled={true}
                            value={this.props.values.destination}
                            {...this.props.getFieldProps("destination")}
                            saveChanges={this.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <TextArea
                            name="comment"
                            value={this.props.values.comment || ''}
                            label="Megjegyzés"
                            disabled={true}
                            {...this.props.getFieldProps("comment")}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <Items {...this.props} />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(WriteOffForm);
